function normalizePhone(phoneValue) {
    return (phoneValue || "").replace(/\D/g, "");
}

function formatPhone(rawValue) {
    const digits = normalizePhone(rawValue);
    const hasPlus = (rawValue || "").trim().startsWith("+");

    if (!digits) {
        return hasPlus ? "+" : "";
    }

    const c = digits.slice(0, 3);
    const a = digits.slice(3, 5);
    const p1 = digits.slice(5, 8);
    const p2 = digits.slice(8, 11);

    let out = "";
    if (c) {
        out += `+${c}`;
    }
    if (a) {
        out += ` (${a}`;
        if (a.length === 2) {
            out += ")";
        }
    }
    if (p1) {
        out += ` ${p1}`;
    }
    if (p2) {
        out += ` ${p2}`;
    }
    return out.trim();
}

export default function memberPhoneLabel() {
    const signupForm = document.querySelector('form[data-members-form="signup"]');
    if (!signupForm) {
        return;
    }

    const nameInput = signupForm.querySelector("#gh-signup-name");
    const phoneInput = signupForm.querySelector("#gh-signup-phone");
    const emailInput = signupForm.querySelector("#gh-signup-email");
    const labelInput = signupForm.querySelector("#gh-signup-phone-label");

    if (!phoneInput || !labelInput || !nameInput || !emailInput) {
        return;
    }

    const setPhoneLabel = () => {
        const digits = normalizePhone(phoneInput.value);
        labelInput.value = digits ? `phone-${digits}` : "";
    };

    const formatAndStore = () => {
        const digits = normalizePhone(phoneInput.value);
        phoneInput.value = formatPhone(phoneInput.value);
        labelInput.value = digits ? `phone-${digits}` : "";
    };

    phoneInput.addEventListener("input", formatAndStore);
    signupForm.addEventListener("submit", () => {
        formatAndStore();
        setPhoneLabel();
    });
}
